import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsTagObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The tag object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the tag.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'The board this tag is associated with.',
                heading: 'board',
                subheading: 'Board object',
              },
              {
                description: 'Time at which the tag was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The name of the tag.',
                heading: 'name',
                subheading: 'string',
              },
              {
                description: 'The number of posts that have been assigned this tag.',
                heading: 'postCount',
                subheading: 'number',
              },
              {
                description:
                  'The URL to the board, filtered to just posts that have been assigned this tag.',
                heading: 'url',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example tag object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba12bb",
  "board": {
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba4400",
    "name": "Feature Requests",
    "postCount": 99,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "created": "2017-08-30T13:32:01.000Z",
  "name": "Example Tag Name",
  "postCount": 12,
  "url": "https://your-company.canny.io/admin/board/feature-requests?tag=example-tag-name"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
